var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfotip = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 25,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m1.113 24.15 1.542-4.598A11.815 11.815 0 0 1 0 12.076 12 12 0 1 1 12 24a12.01 12.01 0 0 1-5.85-1.514L1.113 24.15Z",
  fill: "#88CA11"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.25 18.654c0 .164-.09.246-.27.246h-3.96c-.18 0-.27-.082-.27-.246v-.883c0-.164.09-.246.27-.246h1.14v-7.35h-1.14c-.18-.005-.27-.09-.27-.254v-.883c0-.165.09-.248.27-.248h2.613a.22.22 0 0 1 .25.246v8.487h1.097c.18 0 .27.082.27.246v.885ZM11.99 5.4a1.107 1.107 0 0 1 .819.35 1.136 1.136 0 0 1 .342.822 1.07 1.07 0 0 1-.342.801 1.14 1.14 0 0 1-.82.328 1.14 1.14 0 0 1-.818-.328 1.07 1.07 0 0 1-.342-.801 1.139 1.139 0 0 1 .342-.822 1.108 1.108 0 0 1 .819-.35Z",
  fill: "#fff"
})));
export { SvgInfotip as ReactComponent };
export default __webpack_public_path__ + "/assets/d8f3c20eec5dbad388c2c754b121b9e3.svg";